import React from "react";
import { toast } from "react-toastify";
import { Download } from "@mui/icons-material";
import { Button } from "@mui/material";
import moment from "moment";

import { useLazyGetBranchListQuery } from "store/services/branchApi";
import { exportExcelFile } from "utils/exportExcelFile";

const ExportBranchListExcel = ({ filters = {}, disabled = false }) => {
  const [isExporting, setIsExporting] = React.useState(false);
  const [fetchBranches] = useLazyGetBranchListQuery();

  const handleDownload = async () => {
    try {
      setIsExporting(true);

      const response = await fetchBranches({
        status: filters.status || "Active",
        page: 1,
        limit: 100000,
        ...(filters.search && { search: filters.search }),
        ...(filters.myBranches && { myBranches: true }),
      }).unwrap();

      const branches = response?.data || [];
      if (!branches.length) {
        toast.info("No branch records found for the selected filters.");
        return;
      }

      const getLookupName = (value) =>
        typeof value === "string"
          ? value
          : value?.name || value?.label || "N/A";

      const formattedData = branches.map((row, index) => ({
        SN: index + 1,
        Code: row.code || "N/A",
        Name: row.name || "N/A",
        Address: row.address || "N/A",
        Region: getLookupName(row.region),
        District: getLookupName(row.district),
        Municipality: getLookupName(row.municipality),
        Warehouse: getLookupName(row.warehouse),
        Phone: row.phone || "N/A",
       // "Area Covered": row.areasCovered || "N/A",
        "Branch Manager": getLookupName(row.branchManager),
        Status: row.status || "N/A",
        "Created At": row.createdAt
          ? moment(row.createdAt).format("YYYY-MM-DD HH:mm:ss")
          : "N/A",
      }));

      exportExcelFile({
        sheetData: formattedData,
        fileName: "Branch_List",
        columnWidths: [8, 16, 26, 34, 20, 20, 24, 24, 18, 24, 24, 14, 22],
        rowHeight: 24,
      });
      toast.success("Branch data downloaded successfully");
    } catch (error) {
      console.error("Error fetching branch data:", error);
      toast.error(error?.data?.message || "Error downloading branch data");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Button
      startIcon={<Download />}
      variant="outlined"
      size="small"
      onClick={handleDownload}
      disabled={disabled || isExporting}
    >
      {isExporting ? "Exporting..." : "Export"}
    </Button>
  );
};

export default ExportBranchListExcel;
